import React from "react";
import { Link } from "react-router-dom";

import Location from "../../assets/Icons/map.svg";
import Phone from "../../assets/Icons/phone.svg";
import Time from "../../assets/Icons/time.svg";
import Message from "../../assets/Icons/message.svg";

import "./Footer.css";

const footer = (props) => (
	<footer className="footer">
		<nav className="footer_navigation">
			<Link to="/umokkur/stadsetning" className="footerItem">
				<img className="footerIcon" src={Location} alt="" />
				<span>Íþróttamiðstöð Laugardal</span>
			</Link>

			<Link to="/timabokun" className="footerItem">
				<img className="footerIcon" src={Phone} alt="" />
				<span>Móttaka: 5526600</span>
			</Link>

			<Link to="/timabokun" className="footerItem">
				<img className="footerIcon" src={Message} alt="" />
				<span>afgreidsla@atlasendurhaefing.is</span>
			</Link>

			<Link to="/umokkur/stadsetning" className="footerItem">
				<img className="footerIcon" src={Time} alt="" />
				<span>mán-fim 8:00-16:30 / fös 8:00-16:00</span>
			</Link>
		</nav>
	</footer>
);

export default footer;
